var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1875 8.18205C5.70527 8.18205 6.125 8.58908 6.125 9.09117V19.0915C6.125 19.5936 5.70527 20.0006 5.1875 20.0006C4.66973 20.0006 4.25 19.5936 4.25 19.0915V9.09117C4.25 8.58908 4.66973 8.18205 5.1875 8.18205Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.774587 14.8121C1.1407 14.4571 1.7343 14.4571 2.10041 14.8121L5.1875 17.8058L8.27459 14.8121C8.6407 14.4571 9.2343 14.4571 9.60041 14.8121C9.96653 15.1672 9.96653 15.7428 9.60041 16.0978L5.85041 19.7343C5.4843 20.0893 4.8907 20.0893 4.52459 19.7343L0.774587 16.0978C0.408471 15.7428 0.408471 15.1672 0.774587 14.8121Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8125 11.8185C10.2947 11.8185 9.875 11.4115 9.875 10.9094L9.875 0.909117C9.875 0.407025 10.2947 -2.19471e-08 10.8125 0C11.3303 2.19471e-08 11.75 0.407025 11.75 0.909117L11.75 10.9094C11.75 11.4115 11.3303 11.8185 10.8125 11.8185Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2254 5.18843C14.8593 5.54346 14.2657 5.54346 13.8996 5.18843L10.8125 2.1948L7.72541 5.18843C7.3593 5.54346 6.7657 5.54346 6.39959 5.18843C6.03347 4.8334 6.03347 4.25777 6.39959 3.90274L10.1496 0.266274C10.5157 -0.0887579 11.1093 -0.0887579 11.4754 0.266275L15.2254 3.90274C15.5915 4.25778 15.5915 4.8334 15.2254 5.18843Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrows);
export default __webpack_public_path__ + "static/media/icon-arrows.4f044a2d387922e81c2bc2dd7d66706d.svg";
export { ForwardRef as ReactComponent };